export default "__VITE_PUBLIC_ASSET__a8a95bcd__"